import { createI18n } from 'vue-i18n'
import de from '@/locales/de.json'
import en from '@/locales/en.json'
import fr from '@/locales/fr.json'
import ru from '@/locales/ru.json'
import { DEFAULT_LOCALE, FALLBACK_LOCALE } from '@/config/locales'

const messages = { en, ru, de, fr }

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  messages,
  pluralRules: {
    ru: (choice: number, choicesLength: number): number => {
      if (choice === 0) return 0

      const teen = choice > 10 && choice < 20
      const endsWithOne = choice % 10 === 1

      if (choicesLength < 4) return !teen && endsWithOne ? 1 : 2
      if (!teen && endsWithOne) return 1
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) return 2

      return choicesLength < 4 ? 2 : 3
    },
  },
  datetimeFormats: {
    en: { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    ru: { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    de: { short: { year: 'numeric', month: 'short', day: 'numeric' } },
    fr: { short: { year: 'numeric', month: 'short', day: 'numeric' } },
  },
  numberFormats: {
    en: { currency: { style: 'currency', currency: 'USD' } },
    ru: { currency: { style: 'currency', currency: 'RUB' } },
    de: { currency: { style: 'currency', currency: 'EUR' } },
    fr: { currency: { style: 'currency', currency: 'EUR' } },
  },
})
